// LaShop Collection Sort - Default to Best Selling
// Redirects to best-selling sort if no sort_by param is present
(function() {
  if (window.location.pathname.indexOf('/collections/') === -1) return;
  var params = new URLSearchParams(window.location.search);
  if (!params.has('sort_by') && !params.has('filter.p')) {
    // Only set default sort on initial collection page load
    // Check if there's no active filter/sort
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', 'best-selling');
    // Use replaceState to avoid adding to browser history
    window.history.replaceState(null, '', url.toString());
    // Also update the sort select if it exists
    var sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.value = 'best-selling';
    }
  }
})();
